export default "__VITE_ASSET__DZXA2TCn__"